import { gql } from '__generated__';

export default gql(`
  mutation EditProduct($input: EditProductInput!) {
    editProduct(input: $input) {
      ...ProductFields
    }
  }
`);
